const productImageBanner  = ()=>({
  bannerLabel: null,
  productContainer:null,
  init(){
    this.productContainer = document.querySelector("[data-main-product]")
    this.bannerLabel = document.querySelector(".pdp-image-banner__label")

    if (this.bannerLabel){
      setTimeout(()=>{
        this.bannerLabel.classList.add("show")
      }, 200)
    }
  },
  scrollToBuyingArea(){
    if (this.productContainer){
      const sectionTop = this.productContainer.getBoundingClientRect().top + window.scrollY
      window.scrollTo({
        top: sectionTop, // vertical position in pixels
        behavior: 'smooth' // or 'auto'
      });
    }
  }
})

export default productImageBanner

window.addEventListener("alpine:init", ()=>{
  Alpine.data("productImageBanner", productImageBanner)
})